import { InternalServerErrorException } from '../../../common/exceptions/exceptions';
import { LogManager } from '../../../common/port/log/log.manager.port';
import { GetAccountSentimentReportTimeSeriesApplicationService } from '../../../core/application/services/sentiment/get-account-sentiment-report-time-series.application-service';
import { AccountSentimentReportTimeSeriesAggregateRoot } from '../../../core/domain/aggregates/sentiment/account-sentiment-report-time-series.aggregate-root';
import { GetAccountSentimentReportTimeSeriesRequestDto } from '../../dtos/sentiment/get-account-sentiment-report-time-series.request.dto';

export class GetAccountSentimentReportTimeSeriesQuery {
  constructor(
    protected readonly logManager: LogManager,
    protected readonly service: GetAccountSentimentReportTimeSeriesApplicationService
  ) {}
  async execute(
    props: GetAccountSentimentReportTimeSeriesRequestDto
  ): Promise<AccountSentimentReportTimeSeriesAggregateRoot[]> {
    try {
      return await this.service.execute(props);
    } catch (error) {
      throw new InternalServerErrorException(error);
    }
  }
}
